export default __webpack_public_path__ + "static/media/property.159ae1ea.svg";